import { testimonials } from "@/mocks/products";

const StarRating = ({ count }: { count: number }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: count }).map((_, i) => (
      <i key={i} className="ri-star-fill text-amber-400 text-sm" />
    ))}
  </div>
);

const Testimonials = () => {
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-br from-[#f0f8ff] via-white to-[#fff0f5] px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-transparent bg-clip-text bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a]">
            Happy Customers
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            What They Say
          </h2>
          <div className="w-16 h-0.5 bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] mx-auto rounded-full" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-6 border border-gray-100 hover:-translate-y-1 transition-all duration-300 flex flex-col"
            >
              {/* Quote icon */}
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#5FA8D3]/10 to-[#F78FB3]/10 mb-4 flex-shrink-0">
                <i className="ri-double-quotes-l text-transparent bg-clip-text bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] text-xl" />
              </div>

              <StarRating count={t.rating} />

              <p className="text-gray-600 text-sm leading-relaxed mt-3 mb-5 flex-1 italic">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-900">{t.name}</p>
                  <p className="text-xs text-gray-400">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
